__turbopack_context__.v({
  "source": "CodeSource-module__6Ss_eW__source",
});
